var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.23 23.2598L24.69 22.9698C24.3914 22.9347 24.0886 22.9678 23.8046 23.0665C23.5206 23.1652 23.2626 23.327 23.05 23.5398L21.21 25.3798C18.3712 23.936 16.0638 21.6286 14.62 18.7898L16.47 16.9398C16.9 16.5098 17.11 15.9098 17.04 15.2998L16.75 12.7798C16.6933 12.2919 16.4592 11.842 16.0923 11.5156C15.7253 11.1892 15.2511 11.0092 14.76 11.0098H13.03C11.9 11.0098 10.96 11.9498 11.03 13.0798C11.56 21.6198 18.39 28.4398 26.92 28.9698C28.05 29.0398 28.99 28.0998 28.99 26.9698V25.2398C29 24.2298 28.24 23.3798 27.23 23.2598Z",
    fill: "#F4BA40"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    stroke: "#DDDDDD",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskCall);
export default __webpack_public_path__ + "static/media/task_call.be0463665df02a98b98f75828f21d38e.svg";
export { ForwardRef as ReactComponent };